module.exports = __webpack_public_path__ + "static/media/edit.b8033d59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/edit.svg
// module id = 189
// module chunks = 5